/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type { AttendContactAbsenceJson } from '@/types/domain/attendContact/entities/attendContactAbsenceEntity';
import type { AttendContactLateJson } from '@/types/domain/attendContact/entities/attendContactLateEntity';
import type { AttendContactLeaveEarlyJson } from '@/types/domain/attendContact/entities/attendContactLeaveEarlyEntity';
import type { AttendContactStateType } from '@/types/domain/attendContact/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: AttendContactStateType = {
  attendContactAbsenceList: [],
  attendContactLateList: [],
  attendContactLeaveEarlyList: [],
  nextTokenAbsence: null,
  nextTokenLate: null,
  nextTokenLeaveEarly: null,
};

/**
 * 出席連絡Slice
 */
export const attendContactSlice = createSlice({
  name: 'attendContact',
  initialState,
  reducers: {
    /** setAttendContactAbsences */
    setAttendContactAbsences:
      (state, action: PayloadAction<{
        nextToken: string,
        items: AttendContactAbsenceJson[],
      }>) => {
        state.attendContactAbsenceList = action.payload.items;
        state.nextTokenAbsence = action.payload.nextToken;
      },
    /** setAttendContactLates */
    setAttendContactLates:
      (state, action: PayloadAction<{
        nextToken: string,
        items: AttendContactLateJson[],
      }>) => {
        state.attendContactLateList = action.payload.items;
        state.nextTokenLate = action.payload.nextToken;
      },
    /** setAttendContactLeaveEarlys */
    setAttendContactLeaveEarlys:
      (state, action: PayloadAction<{
        nextToken: string,
        items: AttendContactLeaveEarlyJson[],
      }>) => {
        state.attendContactLeaveEarlyList = action.payload.items;
        state.nextTokenLeaveEarly = action.payload.nextToken;
      },
    /** 作成 */
    createAttendContactAbsenceStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactAbsenceList = service.attendContact.createAbsenceStore(
        state.attendContactAbsenceList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateAttendContactAbsenceStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactAbsenceList = service.attendContact.updateAbsenceStore(
        state.attendContactAbsenceList,
        action.payload,
      );
    },
    /** 削除 */
    deleteAttendContactAbsenceStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.attendContactAbsenceList = service.attendContact.deleteAbsenceStore(
        state.attendContactAbsenceList,
        action.payload,
      );
    },
    /** 作成 */
    createAttendContactLateStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactLateList = service.attendContact.createLateStore(
        state.attendContactLateList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateAttendContactLateStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactLateList = service.attendContact.updateLateStore(
        state.attendContactLateList,
        action.payload,
      );
    },
    /** 削除 */
    deleteAttendContactLateStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.attendContactLateList = service.attendContact.deleteLateStore(
        state.attendContactLateList,
        action.payload,
      );
    },
    /** 作成 */
    createAttendContactLeaveEarlyStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactLeaveEarlyList = service.attendContact.createLeaveEarlyStore(
        state.attendContactLeaveEarlyList,
        action.payload,
        undefined,
      );
    },
    /** 更新 */
    updateAttendContactLeaveEarlyStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.attendContactLeaveEarlyList = service.attendContact.updateLeaveEarlyStore(
        state.attendContactLeaveEarlyList,
        action.payload,
      );
    },
    /** 削除 */
    deleteAttendContactLeaveEarlyStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.attendContactLeaveEarlyList = service.attendContact.deleteLeaveEarlyStore(
        state.attendContactLeaveEarlyList,
        action.payload,
      );
    },
  },
});
